import { cn } from '@repo/ui/lib/utils'
import { ReactNode } from 'react'


interface Props {
  children: ReactNode
  className?: string
}

export default function SectionContainer({ children, className }: Props) {
  return (
    <div className={cn("mx-auto max-w-[1220px] pl-4 md:pl-0 ", className)}>
      {children}
    </div>
  );
}
